import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import {
  Col,
  FormGroup,
  Label,
  Input,
  Spinner,
  Badge,
  Alert,
  Card,
  CardBody,
  CardHeader,
} from 'reactstrap'
import { Link } from 'gatsby'
import { PaymentsContext } from './PaymentsContext'

const PaymentMethods = ({ onChange, gateway }) => {
  const paymentoptions = useContext(PaymentsContext)
  return (
    <FormGroup tag="fieldset" row>
      {/* eslint-disable */}
      {paymentoptions.loading && !paymentoptions.loaded && (
        <div className="text-center">
          <Spinner
            style={{ width: '3rem', height: '3rem' }}
            className="mt-4 mb-1"
          />
          <div className="text-center mb-4">Please wait..</div>
        </div>
      )}
      {/* eslint-enable */}
      {paymentoptions.loaded && (
        <Col sm={12}>
          {/* {paymentoptions.data.includes(1) && (
            <FormGroup check className="pb-4">
              <Label check>
                <Input
                  type="radio"
                  name="gateway"
                  value="paypal"
                  onChange={onChange}
                  checked={gateway === 'paypal'}
                />{' '}
                <i className="fab fa-paypal fa-2x" /> Paypal{'  '}
                <Badge color="warning p-1" pill>
                  <i className="fas fa-parachute-box pr-1" />
                  Recommended
                </Badge>
              </Label>
            </FormGroup>
          )} */}
          {/* <FormGroup check>
            <Label check className="pb-4">
              <Input
                type="radio"
                name="gateway"
                value="pmu-card"
                onChange={onChange}
                checked={gateway === 'pmu-card'}
              />{' '}
              <i className="far fa-credit-card fa-2x" /> Credit/Debit Card{' '}
              <small className="text-danger">(Reseller - Premium.us) </small>
              <Badge color="warning p-1" pill>
                <i className="fas fa-parachute-box pr-1" />
                New
              </Badge>
            </Label>
          </FormGroup> */}
          {/*
          <FormGroup check>
            <Label check className="pb-4">
              <Input
                type="radio"
                name="gateway"
                value="stripe"
                onChange={onChange}
                checked={gateway === 'stripe'}
              />{' '}
              <i className="fab fa-cc-stripe fa-2x align-middle ml-2" />{' '}
              Credit/Debit Card
              <Badge color="warning p-1 ml-2" pill>
                <i className="fas fa-star pr-1" />
                New (Instant Activation)
              </Badge>
            </Label>
          </FormGroup>
          */}
          {/* <Card className="my-2">
            <CardHeader className="text-danger">
              <strong>
                <i className="fas fa-store mr-2"></i>Filesharingshop.com
              </strong>
            </CardHeader>
            <CardBody>
              <FormGroup check>
                <Label check className="pb-4">
                  <Input
                    type="radio"
                    name="gateway"
                    value="fss-card"
                    onChange={onChange}
                    checked={gateway === 'fss-card'}
                  />{' '}
                  <i className="far fa-credit-card fa-2x align-middle ml-2" />{' '}
                  Credit Card{' '}
                </Label>
              </FormGroup>
              <FormGroup check>
                <Label check className="pb-4">
                  <Input
                    type="radio"
                    name="gateway"
                    value="fss-paypal"
                    onChange={onChange}
                    checked={gateway === 'fss-paypal'}
                  />{' '}
                  <i className="fab fa-paypal fa-2x align-middle ml-2" /> Paypal{' '}
                </Label>
              </FormGroup>
            </CardBody>
          </Card> */}
          <Card className="my-2">
            <CardHeader className="text-danger">
              <strong>
                <i className="fas fa-store mr-2"></i>TakePremium
              </strong>{' '}
            </CardHeader>
            <CardBody>
              <FormGroup check>
                <Label check className="pb-4">
                  <Input
                    type="radio"
                    name="gateway"
                    value="tkp-card"
                    onChange={onChange}
                    checked={gateway === 'tkp-card'}
                  />{' '}
                  <i className="far fa-credit-card fa-2x align-middle ml-2" />{' '}
                  Credit Card{' '}
                </Label>
              </FormGroup>
              <FormGroup check>
                <Label check className="pb-4">
                  <Input
                    type="radio"
                    name="gateway"
                    value="tkp-paypal"
                    onChange={onChange}
                    checked={gateway === 'tkp-paypal'}
                  />{' '}
                  <i className="fab fa-paypal fa-2x align-middle ml-2" /> Paypal{' '}
                </Label>
              </FormGroup>
            </CardBody>
          </Card>
          <Card className="my-2">
            <CardHeader>
              <strong className="text-danger">
                <i className="fas fa-store mr-2"></i>Premium Key Store
              </strong>{' '}
              <Badge color="primary">New</Badge>
            </CardHeader>
            <CardBody>
              <FormGroup check>
                <Label check className="pb-4">
                  <Input
                    type="radio"
                    name="gateway"
                    value="pks-pay"
                    onChange={onChange}
                    checked={gateway === 'pks-pay'}
                  />{' '}
                  <i className="far fa-credit-card fa-2x align-middle ml-2" />{' '}
                  Credit/Debit Card
                </Label>
              </FormGroup>
            </CardBody>
          </Card>
          <Card className="my-2">
            <CardHeader>
              <strong className="text-danger">
                <i className="fas fa-store mr-2"></i>FilesharingKey.com
              </strong>{' '}
            </CardHeader>
            <CardBody>
              <FormGroup check>
                <Label check className="pb-4">
                  <Input
                    type="radio"
                    name="gateway"
                    value="fsk-card"
                    onChange={onChange}
                    checked={gateway === 'fsk-card'}
                  />{' '}
                  <i className="far fa-credit-card fa-2x align-middle ml-2" />{' '}
                  Credit Card / Paypal
                </Label>
              </FormGroup>
            </CardBody>
          </Card>
          {/* <FormGroup check>
            <Label check className="pb-4">
              <Input
                type="radio"
                name="gateway"
                value="bitcoin"
                onChange={onChange}
                checked={gateway === 'bitcoin'}
              />{' '}
              <i className="fab fa-bitcoin fa-2x" /> Bitcoin
            </Label>
          </FormGroup> */}
          {/* <FormGroup check>
            <Label check className="pb-2">
              <Input
                type="radio"
                name="gateway"
                value="paytm"
                onChange={onChange}
                checked={gateway === 'paytm'}
              />{' '}
              <i className="fas fa-rupee-sign fa-2x align-middle ml-2" /> PayTM
              (Only for Indians)
            </Label>
          </FormGroup> */}
          <Alert color="secondary" className="mt-4">
            <strong>Note:</strong> <br />
            For PayTM/PhonePe/GooglePay/UPI Payments{' '}
            <Link to="/contact" className="text-danger">
              Contact Support
            </Link>
          </Alert>
        </Col>
      )}
    </FormGroup>
  )
}

PaymentMethods.propTypes = {
  onChange: PropTypes.func.isRequired,
  gateway: PropTypes.string.isRequired,
}

export default PaymentMethods
